import React from 'react';
import "./filtertitle.css"

const FilterTitle = (props) => {
    return ( 

        <>
            <h1>{props.title}</h1>    
        </>
     );
}
 
export default FilterTitle;